// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.successMain {
  width: 100%;
  display: flex;
  justify-content: center;
}

.successMob {
  display: none;
}
@media (max-width: 1200px) {
  .successMob {
    margin-top: 1.5rem;
    display: flex !important;
  }
}

.successDesktop {
  display: flex !important;
}
@media (max-width: 1200px) {
  .successDesktop {
    display: none !important;
  }
}

.successContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: pointer;
}

.success-content {
  border-radius: 4.24vh !important;
  padding: 0 !important;
}

.content {
  position: relative;
  width: 100%;
  max-width: 70%;
  overflow: hidden;
  border-radius: 4.24vh;
}
@media (max-width: 768px) {
  .content {
    max-width: 100%;
  }
}

.content .content-overlay {
  background: linear-gradient(221deg, rgba(255, 182, 160, 0.4) 0%, rgba(240, 89, 42, 0.4) 0%, rgba(8, 16, 38, 0.4) 100%);
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  opacity: 1;
  transition: all 0.4s ease-in-out 0s;
}

.content-image {
  width: 100%;
}

.content-details {
  font-family: "Helvetica";
  position: absolute;
  padding-left: 2em;
  padding-right: 2em;
  width: 100%;
  top: 70%;
  left: 50%;
  opacity: 1;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out 0s;
}
@media (max-width: 1024px) {
  .content-details {
    top: 65% !important;
  }
}
@media (max-width: 992px) {
  .content-details {
    top: 55% !important;
  }
}

.content-details h3 {
  color: #fff;
  text-align: left;
  font-size: 1.1vw;
}
@media (max-width: 1199px) {
  .content-details h3 {
    font-size: 20px;
  }
}

.content-details p {
  color: #fff;
}

.content-text {
  display: flex;
  justify-content: left;
}

.fadeIn-bottom {
  top: 80%;
}

@media (max-width: 768px) {
  .successMain {
    width: 100%;
  }
  .successContainer {
    width: 90%;
    margin-bottom: 5%;
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .content-details h3 {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Success/success.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EAHF;IAII,kBAAA;IACA,wBAAA;EAEF;AACF;;AACA;EACE,wBAAA;AAEF;AAAE;EAHF;IAII,wBAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAGF;;AAAA;EACE,gCAAA;EACA,qBAAA;AAGF;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAGF;AAFE;EANF;IAOI,eAAA;EAKF;AACF;;AAFA;EACE,sHAAA;EAMA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EAGA,mCAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAGA,gCAAA;EAGA,mCAAA;AAAF;AACE;EAfF;IAgBI,mBAAA;EAEF;AACF;AADE;EAlBF;IAmBI,mBAAA;EAIF;AACF;;AADA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAIF;AAFE;EALF;IAMI,eAAA;EAKF;AACF;;AAFA;EACE,WAAA;AAKF;;AAFA;EACE,aAAA;EACA,qBAAA;AAKF;;AAFA;EACE,QAAA;AAKF;;AAFA;EACE;IACE,WAAA;EAKF;EAFA;IACE,UAAA;IACA,iBAAA;IACA,aAAA;IACA,uBAAA;EAIF;AACF;AADA;EACE;IACE,eAAA;EAGF;AACF","sourcesContent":[".successMain {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.successMob {\n  display: none;\n\n  @media (max-width: 1200px) {\n    margin-top: 1.5rem;\n    display: flex !important;\n  }\n}\n\n.successDesktop {\n  display: flex !important;\n\n  @media (max-width: 1200px) {\n    display: none !important;\n  }\n}\n\n.successContainer {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  cursor: pointer;\n}\n\n.success-content {\n  border-radius: 4.24vh !important;\n  padding: 0 !important;\n}\n\n.content {\n  position: relative;\n  width: 100%;\n  max-width: 70%;\n  overflow: hidden;\n  border-radius: 4.24vh;\n  @media (max-width: 768px) {\n    max-width: 100%;\n  }\n}\n\n.content .content-overlay {\n  background: linear-gradient(\n    221deg,\n    rgba(255, 182, 160, 0.4) 0%,\n    rgba(240, 89, 42, 0.4) 0%,\n    rgba(8, 16, 38, 0.4) 100%\n  );\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  opacity: 1;\n  -webkit-transition: all 0.4s ease-in-out 0s;\n  -moz-transition: all 0.4s ease-in-out 0s;\n  transition: all 0.4s ease-in-out 0s;\n}\n\n.content-image {\n  width: 100%;\n}\n\n.content-details {\n  font-family: \"Helvetica\";\n  position: absolute;\n  padding-left: 2em;\n  padding-right: 2em;\n  width: 100%;\n  top: 70%;\n  left: 50%;\n  opacity: 1;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-transition: all 0.3s ease-in-out 0s;\n  -moz-transition: all 0.3s ease-in-out 0s;\n  transition: all 0.3s ease-in-out 0s;\n  @media (max-width: 1024px) {\n    top: 65% !important;\n  }\n  @media (max-width: 992px) {\n    top: 55% !important;\n  }\n}\n\n.content-details h3 {\n  color: #fff;\n  text-align: left;\n  font-size: 1.1vw;\n\n  @media (max-width: 1199px) {\n    font-size: 20px;\n  }\n}\n\n.content-details p {\n  color: #fff;\n}\n\n.content-text {\n  display: flex;\n  justify-content: left;\n}\n\n.fadeIn-bottom {\n  top: 80%;\n}\n\n@media (max-width: 768px) {\n  .successMain {\n    width: 100%;\n  }\n\n  .successContainer {\n    width: 90%;\n    margin-bottom: 5%;\n    display: flex;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 576px) {\n  .content-details h3 {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
